// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2_e94","footer":"Form_footer__2LXhY"};